export default {
    'errors.greaterThan': 'Vlera nuk mund të jetë më e madhe se 100%. Ju vendosët',
    'errors.required.name': 'Emri kërkohet!',
    'errors.unique.name': 'Emri duhet të jetë unik!',
    'errors.required.contact': 'Kërkohet kontakt!',
    'errors.required.phone': 'Numri i telefonit kërkohet!',
    'errors.required.phonePolicyHolder': 'Numri i telefonit është i detyrueshëm për mbajtësin e policës!',
    'errors.required.email': 'Kërkohet email!',
    'errors.required.code': 'Kërkohet kodi!',
    'errors.required.endDate': 'Data e përfundimit kërkohet!',
    'errors.required.tax': 'Numri tatimor kërkohet!',
    'errors.required.customer': 'Kërkohet klienti!',
    'errors.required.commission': 'Kërkohet komision!',
    'errors.required.country': 'Kërkohet vendi!',
    'errors.notValidAlbania': 'Adresë jo e vlefshme për Shqipërinë!',
    'errors.required.plate': 'Targa kërkohet!',
    'errors.required': 'Fusha kërkohet!',
    'errors.required.vin': 'Kërkohet Shasia',
    'errors.required.classification': 'Kërkohet klasifikimi!',
    'errors.required.city': 'Qyteti kërkohet!',
    'errors.required.category': 'Kategoria kërkohet!',
    'errors.required.businessSize': 'Lloji i madhësisë së biznesit kërkohet!',
    'errors.required.legalForm': 'Lloji i formularit ligjor kërkohet!',
    'errors.required.sectorType': 'Lloji i sektorit kërkohet!',
    'errors.required.ownerShip': 'Lloji i pronarit te organizates kërkohet!',
    'errors.required.gender': 'Gjinia kërkohet!',
    'errors.required.make': 'Kërkohet krijimi!',
    'errors.required.model': 'Modeli kërkohet!',
    'errors.required.type': 'Lloji kërkohet!',
    'errors.required.year': 'Kërkohet viti!',
    'errors.required.engine': 'Kërkohet motor!',
    'errors.required.volume': 'Vëllimi kërkohet!',
    'errors.required.fuel': 'Kërkohet karburant!',
    'errors.required.capacity': 'Kërkohet kapacitet!',
    'errors.required.color': 'Ngjyra është e nevojshme!',
    'errors.required.seats': 'Kërkohen vendet e makines!',
    'errors.required.writeComment': 'Ju lutemi shkruani komentin!',
    'errors.exists': 'ekziston!',
    'errors.lowerThan': 'Gabim: Përqindja e Sigal Uniqa nuk mund të jetë më e ulët se 0!',
    'errors.renewalsDays': 'Rinovimi që keni zgjedhur nuk merr parasysh ditët e {name}!',
    'errors.selectAgency': 'Zgjidhni së pari agjencinë e re!',
    'errors.alreadyAssigned': 'Agjenti tashmë është caktuar në agjencinë e përzgjedhur!',
    'errors.required.first.type': 'Zgjidhni fillimisht llojin!',
    'errors.required.hospital': 'Lloji i spitalit kërkohet!',
    'errors.required.website': 'Kërkohet faqja e internetit!',
    'errors.required.insuranceSectorType': 'Lloji i Sektorit të Sigurimeve kërkohet!',
    'errors.required.insuranceSectorTypee': 'Zgjidh llojin e sektorit të sigurimit',
    'errors.required.description': 'Kërkohet përshkrim!',
    'errors.required.years': 'Duhen vite!',
    'errors.required.months': 'Duhen muaj!',
    'errors.required.days': 'Duhen ditë!',
    'errors.required.serialStart': 'Kërkohet fillimi serial!',
    'errors.required.serialEnd': 'Fundi serial kërkohet!',
    'errors.required.agency': 'Kërkohet agjenci!',
    'errors.required.destination': 'Kërkohet destinacioni!',
    'errors.required.insuredPeriod': 'Kërkohet periudha e sigurimit!',
    'errors.required.policyHolder': 'Kërkohet mbajtësi i policës!',
    'errors.required.beneficiary': 'Kërkohet përfituesi!',
    'errors.required.birthday': 'Kërkohet ditëlindja!',
    'errors.required.startDate': 'Data e fillimit kërkohet!',
    'errors.noDrivers': 'Asnjë shofer nuk u zgjodh!',
    'errors.driverExists': 'Ky shofer ekziston. Veprimi u anullua sepse nuk mund te vendosni nje shofer te duplikuar!',
    'errors.clientExists': 'Ky klient tashmë ekziston!',
    'errors.clientisOrganization': 'Klienti nuk mund të jetë lloj organizate!',
    'errors.usersOrganization': 'Përdoruesi nuk mund të jetë lloj organizate!',
    'errors.notaryPerson': 'Noteri nuk mund të jetë lloj person!',
    'errors.serialNotAble': 'Ky serial nuk është në gjendje!',
    'errors.required.drivers': 'Error: Nuk mund te shitet nje police pa te pakten nje shofer. Ju lutemi plotesojeni!',
    'errors.required.phonePH': 'Error: Mbajtesi i polices duhet të ketë një numër telefoni. Ju lutemi plotesoni fushen e kerkuar!',
    'errors.required.coverages': 'Kujdes: Përpara se të finalizoni shitjen, zgjidhni paketen e polices!',
    'errors.vehicleGt': 'Kujdes: Vlera e mjetit duhet të jetë më e madhe se 0',
    'errors.required.dynamicSumInsured': 'Kërkohet vlera e automjetit!',
    'errors.premiumCalculating': 'Kujdes: Primi ishte duke u llogaritur. Provo përsëri!',
    'errors.vehicleValueFirst': 'Kujdes: Përpara se të zgjidhni paketën, vendosni vlerën e automjetit!',
    'errors.required.firstName': 'Kërkohet emri!',
    'errors.required.lastName': 'Mbiemri kërkohet!',
    'errors.required.amfCode': 'Kërkohet kodi AMF!',
    'errors.required.amfUsername': 'Emri i përdoruesit AMF kërkohet!',
    'errors.required.amfPassword': 'Kërkohet fjalëkalimi AMF!',
    'erros.format.phoneNumber': 'Nuk është një numër i vlefshëm telefoni!',
    'errors.premiumAdjusted': 'Primi i rregulluar nuk mund të jetë më i madh se bruto premium aktual!',
    'errors.required.location': 'Kërkohet vendndodhja!',
    'errors.required.duration': 'Kërkohet kohëzgjatja!',
    'errors.required.borderVehicleCategory': 'Kategoria e automjeteve kufitare kërkohet!',
    'errors.required.vehicleFields': 'Duhen të dhënat e automjetit!',
    'errors.required.username': 'Emri i përdoruesit kërkohet!',
    'errors.required.password': 'Fjalëkalimi kërkohet!',
    'errors.confirm.password': 'Ju lutemi konfirmoni fjalëkalimin tuaj!',
    'errors.required.branch': 'Dega kërkohet!',
    'errors.invalid.email': 'Ky nuk është një e-mail i vlefshëm!',
    'errors.required.address': 'Adresa kërkohet!',
    'errors.required.fiscTcr': 'Kërkohet njësia e biznesit!',
    'errors.required.fiscOperatorCode': 'Kërkohet kodi i operatorit!',
    'errors.required.bankAccount': 'Llogaria bankare kërkohet!',
    'errors.length.max.18': 'Vlera duhet të jetë më pak se 18 karaktere!',
    'errors.length.min.18': 'Vlera duhet të jetë 18 karaktere!',
    'errors.required.distributionChannel': 'Kanali i shpërndarjes kërkohet!',
    'errors.required.dateConfirm': 'Kërkohet data e konfirmimit!',
    'errors.required.coverageOptions': 'Opsionet e mbulimeve janë të nevojshme!',
    'errors.required.group': 'Kërkohet grup!',
    'errors.invalidCustomer': 'Error: Klient i pavlefshëm. Ju lutemi plotësoni informacionin e saktë ose e ndryshoni!',
    'errors.required.insurer': 'Kërkohet Siguruesi Tpl!',
    'errors.required.tplSerial': 'Seriali Tpl kërkohet!',
    'errors.dateLimitReached': 'U arrit kufiri i datës!',
    'errors.tryAgain': 'Provo përsëri më vonë',
    'errors.required.objectName': 'Kërkohet emri i objektit!',
    'errors.required.propertyNumber': 'Numri i pasurisë kërkohet!',
    'errors.required.surface': 'Sipërfaqja kërkohet!',
    'errors.required.cadastralArea': 'Kërkohet zona kadestrale!',
    'errors.required.identificationNumber': 'Numri i identifikimit kërkohet!',
    'errors.required.identification': 'Identifikimi kërkohet!',
    'errors.required.livestockType': 'Tipi i bagëtive kërkohet!',
    'errors.required.cultureType': 'Tipi i kultures kërkohet!',
    'errors.required.area': 'Sipërfaqja kërkohet!',
    'errors.required.greenhouseArticleType': 'Tipi i artikullit të serës kërkohet!',
    'errors.required.greenhousePropertyType': 'Tipi i pronës së serës kërkohet!',
    'errors.required.age': 'Mosha kërkohet!',
    'errors.required.propertyType': 'Lloji i pronës kërkohet!',
    'errors.required.insuredAmount': 'Shuma e siguruar kërkohet!',
    'errors.required.ticketConfirmationDate': 'Data e konfirmimit të biletës kërkohet!',
    'error.tooltip.policyHolderLock': 'Nuk mund të hapësh modalin e mbajtësit të policës sepse është i kyçur nga klikimi i kutisë në të majtë',
    'errors.sameBeneficiary': 'Perfituesi i pare nuk mund te jete i njejte me perfituesin e dyte!',
    'errors.sameBeneficiary2': 'Perfituesi i dyte nuk mund te jete i njejte me perfituesin e pare!',
    'errors.columnsTotal': 'Shuma e kolones duhet 100%',
    'errors.ownerShipPercentageTotal': 'Totali i perqindjes tek kolona e tabeles nuk eshte 100%, por eshte {firstArg}!',
    'errors.invoicePercentageTotal': 'Totali i perqindjes per faturimin tek tabela e klienteve nuk eshte 100%, por eshte:',
    'errors.required.waitingPeriod': 'Periudha e pritjes kërkohet!',
    'errors.required.identifier1': 'Kërkohet identifikuesi 1!',
    'errors.required.identifier2': 'Kërkohet identifikuesi 2!',
    'errors.required.productId': 'Produkti kërkohet!',
    'errors.required.blockedType': 'Lloji i bllokimit kerkohet!',
    'errors.invalidCustomersList': 'Kujdes: Lista me personat e siguruar me siper permban kliente te pasakte. Ju lutem perditesojeni!',
    'errors.I00000000I': 'nuk lejohet te jete shoferi kryesor dhe i vetem!',
    'errors.noTemplate': 'Error: Ky produkt nuk permban ndonje pakete. Kontaktoni departamentin e IT!',
    'errors.templateEmpty': 'Error: Paketa e selektuar nuk permban mbulime. Kontaktoni departamentin e IT!',
    'errors.emptyClientsTable': 'Error: Lista e klienteve eshte bosh. Plotesoni te pakten nje klient per te shitur policen!',
    'errors.premium.zero': 'Error: Polica nuk mund të shitet me prim 0 (zero)!',
    'errors.templates.sublimitsNotAvailable': 'Paketa e selektuar nuk permban sublimite.',
    'errors.required.issueDate': 'Data e lëshimit kërkohet!',
    'errors.required.value': 'Vlera kërkohet!',
    'errors.required.relatedAgencyId': 'Agjencia e lidhur kërkohet!',
    'errors.required.fullName': 'Emri i plotë kërkohet!',
    'errors.required.agencyId': 'Agjencia kërkohet!',
    'errors.required.confirm_password': 'Konfirmimi i fjalëkalimit kërkohet!',
    'errors.minimumReachedBeneficiary': 'Ju keni {firstArg} përfitues. Limiti është {secondArg} përfitues minimumi!',
    'errors.minimumReachedInsurer': 'Ju keni {firstArg} sigurues. Limiti është {secondArg} sigurues minimumi!',
    'errors.minimumReachedPolicyHolder': 'Ju keni {firstArg} mbajtës të policës. Limiti është {secondArg} mbajtës të policës minimumi!',
    'errors.minimumReachedPolicyUser': 'Ju keni {firstArg} përdorues. Limiti është {secondArg} përdorues minimumi!',
    'errors.maximumReachedInsurer': 'Ju keni {firstArg} sigurues. Limiti është {secondArg} sigurues maksimumi!',
    'errors.maximumReachedPolicyHolder': 'Ju keni {firstArg} mbajtës të policës. Limiti është {secondArg} mbajtës të policës maksimumi!',
    'errors.maximumReachedPolicyUser': 'Ju keni {firstArg} përdorues. Limiti është {secondArg} përdorues maksimumi!',
    'errors.maximumReachedBeneficiary': 'Ju keni {firstArg} përfitues. Limiti është {secondArg} përfitues maksimumi!',
    'errors.minimumReachedInvoiceRecipient': 'Ju keni {firstArg} faturues. Limiti është {secondArg} faturues minimumi!',
    'errors.maximumReachedInvoiceRecipient': 'Ju keni {firstArg} faturues. Limiti është {secondArg} faturues maksimumi!',
    'errors.maximumReached': 'Kujdes: Numri i pjesëmarrësve ka arritur kufirin!',
    'errors.minimumReached': 'Kujdes: Numri i pjesëmarrësve është nën kufirin!',
    'errors.required.serialCode': 'Kodi i serialit kërkohet!',
    'errors.required.sequence': 'Sekuenca kërkohet!',
    'errors.required.productCatergoryPath': 'Product Category Path is required!',
    'errors.required.uniqueCode': 'Numri i lejes kërkohet!',
    'errors.required.motorProduct': 'Produkti motorik kërkohet!',
    'errors.required.serial': 'Seriali kërkohet!',
    'errors.required.articleType': 'Lloji i artikullit kërkohet!',
    'errors.required.currency': 'Valuta kërkohet!',
    'errors.required.paymentType': 'Lloji i pageses kërkohet!',
    'errors.required.riskAddress': 'Adresa e rrezikut kërkohet!',
    'errors.required.bank': 'Banka kërkohet!',
    'errors.required.bankBranch': 'Dega e bankës kërkohet!',
    'errors.required.addNotary': 'Kërkohet noteri. Klikoni butonin e mësipërm!',
    'errors.required.addInsuranceAgent': 'Kërkohet agjenti i sigurimit. Klikoni butonin e mësipërm!',
    'errors.canSell': 'Ju lutemi kontaktoni departamentin e IT. Sipas konfigurimeve, ju nuk mund ta shisni këtë produkt ose paketë!',
    'errors.required.retroactiveDate': 'Data paravepruese kërkohet!',
    'errors.required.accountId': 'Llogaria kërkohet!',
    'errors.required.date': 'Data kërkohet!',
    'errors.required.amount': 'Shuma kërkohet!',
    'errors.invalidFormFields': 'Fushat e formës janë të pavlefshme!',
    'errors.deleteDisabled': 'Nuk mund të fshini këtë rresht!',
    'errors.required.add': 'Kërkohet objekti i siguruar!',
    'errors.required.specification': 'Kërkohet specifikim!',
    'errors.required.preventiveValue': 'Kërkohet vlera e preventivit!',
    'errors.required.project': 'Projekti kërkohet!',
    'errors.required.insuredUserLicenseNumber': 'Kërkohet numri i licencës!',
    'errors.length.9': 'Vlera duhet të jetë më pak se 9 shifra',
    'errors.required.product': 'Produkti kërkohet!',
    'errors.required.vesselCategory': 'Kategoria e mjetit lundrues kërkohet!',
    'errors.required.material': 'Materiali i mjetit lundrues kërkohet!',
    'errors.required.transportDocuments': 'Dokumenti i transportit kërkohet!',
    'errors.required.voyageOrigin': 'Origjina e udhetimit kërkohet!',
    'errors.required.voyageDestination': 'Destinacioni e udhetimit kërkohet!',
    'errors.required.cargoDescription': 'Pershkrimi i ngarkeses kërkohet!',
    'errors.required.packageType': 'Lloji i paketes kërkohet!',
    'errors.required.transportationType': 'Lloji i transportit kërkohet!',
    'errors.required.cargoType': 'Lloji i ngarkeses kërkohet!',
    'errors.required.shouldHidePremium': ' Ju lutemi konfirmoni nëse dëshironi të fshihet primi!',
    'errors.required.serialNumber': 'Numri serial kërkohet!',
    'errors.required.invoiceNumber': 'Numri i fatures kërkohet!',
    'errors.required.purchasePrice': 'Cmimi i blerjes kërkohet!',
    'errors.required.purchaseCurrency': 'Valuta e blerjes kërkohet!',
    'errors.required.sellerWarrantyStartDate': 'Data e fillimit te garancise se shitesit kërkohet!',
    'errors.required.sellerWarrantyEndDate': 'Data e perfundimit te garancise se shitesit kërkohet!',
    'errors.required.channelType': 'Lloji i kanalit kërkohet!',
    'errors.required.scopeType': 'Lloji i shtrirjes kërkohet!',
    'errors.required.value': 'Vlera kërkohet!',
    'errors.required.reason': 'Arsyeja kërkohet!',
};
